

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFieldError } from '../../models/IFieldError';
import { IFieldProps } from '../../models/IFieldProps';

interface IPasswordRecoveryFields {
  helloWorld: IFieldProps<string>

}

interface IPasswordRecoveryState {
  fields: IPasswordRecoveryFields,
  error?: IFieldError,
}

const initialState: IPasswordRecoveryState = {
  fields: {
    helloWorld: {
      value: '',
      isValid: true,
      validate() {
        if(this.value === 'hello world') {
          return undefined
        } else {
          return {
            message: 'Hello world is not valid',
            type: 'error'
          }
        }

      },
    }
  }
};

const helloWorldSlice = createSlice({
  name: 'helloWorld',
  initialState,
  reducers: {
    setHelloWorldState(state, action: PayloadAction<{
      value: string,
    }>) {
      state.fields.helloWorld.value = action.payload.value
    },
    setError(state, action: PayloadAction<IFieldError | undefined>) {
      state.error = action.payload
    },
    validateField(state, action: PayloadAction<{
      key: keyof IPasswordRecoveryFields,
      value?: string
    }>) {
      const field = state.fields[action.payload.key]
      if (field.validate) {
        field.error = field.validate(action.payload.value)
        field.isValid = !field.error
      }
    },
    resetHelloWorld(state) {
      state.fields = initialState.fields
      state.error = undefined
    }
  },
});

export const {
  setHelloWorldState,
  setError,
  validateField,
  resetHelloWorld
} = helloWorldSlice.actions;


export const helloWorldReducer = helloWorldSlice.reducer;